// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"yV-z","sponsoredTooltipWrapper":"zV-z","sponsoredTooltip":"AV-z","newCard":"BV-z"};